import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import RegistryView from "./view/RegistryView";
import authenticate, { logOut } from "../authenticate";
import feathersClient from "../services/feathersService";
import _ from "lodash";

export const SessionDataContext = React.createContext({
  user: null,
  authenticated: false,
  loading: false,
  error: null,
  authenticate: authenticate(feathersClient),
  logOut: logOut(feathersClient)
});

const helperCreateSubscriptions = (
  service,
  handler,
  events = ["created", "updated", "patched", "removed"]
) => {
  let removers = [];
  let subscriptions = events.reduce((partial, anEvent) => {
    let handlerFunc = handler(anEvent);
    removers.push(() => service.removeListener(anEvent, handlerFunc));
    return { ...partial, [anEvent]: service.on(anEvent, handlerFunc) };
  }, {});
  return {
    subscriptions,
    remover: () => removers.forEach(element => element())
  };
};

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      authenticated: false,
      loading: false,
      error: null
    };
    this.listener = null;
  }

  onUserChange = event => user => {
    //console.log(event);
    if (event === "patched" || event === "updated") {
      // //console.log(user);
      if (
        this.state.user &&
        this.state.authenticated &&
        user.id === this.state.user.id
      ) {
        // console.log(
        //   _.omit(this.state.user, [
        //     "createdAt",
        //     "updatedAt",
        //     "verifyChanges",
        //     "verifyToken",
        //     "verifyExpires",
        //     "resetToken",
        //     "resetExpires"
        //   ])
        // );
        // //console.log(
        //   _.omit(user, [
        //     "createdAt",
        //     "updatedAt",
        //     "verifyChanges",
        //     "verifyToken",
        //     "verifyExpires",
        //     "resetToken",
        //     "resetExpires"
        //   ])
        // );
        if (
          !_.isEqual(
            _.omit(this.state.user, [
              "createdAt",
              "updatedAt",
              "verifyChanges",
              "verifyToken",
              "verifyExpires",
              "resetToken",
              "resetExpires"
            ]),
            _.omit(user, [
              "createdAt",
              "updatedAt",
              "verifyChanges",
              "verifyToken",
              "verifyExpires",
              "resetToken",
              "resetExpires"
            ])
          )
        )
          this.authenticate(undefined, true);
        return;
      }
    } else {
      this.props.authenticate();
    }
  };

  _authenticate = options => {
    return authenticate(feathersClient)(options);
  };

  _logOut = () => {
    return logOut(feathersClient)();
  };

  logOut = async () => {
    this.setState({
      loading: true,
      error: null,
      user: null,
      authenticated: false
    });
    if (!!this.listener) {
      this.listener.remover();
      this.listener = null;
    }
    try {
      await this._logOut();
    } catch (error) {
      //console.log("error.logout", error);
    }
    this.setState({
      loading: false,
      error: null,
      user: null,
      authenticated: null
    });
    window.localStorage.removeItem("feathers-jwt");
  };

  authenticate = async (options, seamless = false) => {
    if (seamless) {
      this.setState({
        loading: true,
        error: null
      });
    }

    try {
      let user = await this._authenticate(options);
      this.setState({ user, loading: false, error: null, authenticated: true });
      this.listener = helperCreateSubscriptions(
        feathersClient.service("api/users"),
        this.onUserChange,
        ["updated", "patched", "removed"]
      );
      return user;
    } catch (error) {
      this.setState({
        error,
        loading: false,
        authenticated: false,
        user: null
      });
      if (!!this.listener) {
        this.listener.remover();
        this.listener = null;
      }
      return error;
    }
  };

  componentDidMount() {
    window.document.title = "Martin Bike - Seguimiento de Bicicletas";
    // let currentJWT = window.localStorage.getItem("feathers-jwt");
    // if (!!currentJWT && currentJWT.length > 0) {
    //   this.authenticate();
    // }
  }

  componentWillUnmount() {
    // if (!!this.listener) {
    //   this.listener.remover();
    //   this.listener = null;
    // }
  }

  render() {
    return (
      <SessionDataContext.Provider
        value={{
          ...this.state,
          authenticate: options => this.authenticate(options),
          logOut: () => this.logOut()
        }}>
        <Router>
          <div>
            {/* <Route
              path="/"
              exact
              render={() =>
                this.state.authenticated && this.state.user ? (
                  <UploadRegister user={this.state.user} logOut={this.logOut} />
                ) : (
                  <HomePageView
                    user={this.state.user}
                    authenticate={this.authenticate}
                    loading={this.state.loading}
                    error={this.state.error}
                  />
                )
              }
            /> */}
            <Route
              path="/id/:registryInternalCode/code/:registryHash"
              component={RegistryView}
            />
            {/* <Route path="/upload" component={UploadRegister} /> */}
          </div>
        </Router>
      </SessionDataContext.Provider>
    );
  }
}

export default App;
